import(/* webpackMode: "eager" */ "/app/app/obrigado/page.tsx");
